<ng-container *ngIf="roleList?.length && localesList?.length">
  <formly-form [fields]="fields" [form]="form">
  </formly-form>
</ng-container>
